module.exports = __webpack_public_path__ + "static/media/ac.f214acab.jpg";